import React, { Component } from 'react'
import { Container,Form,Col } from 'react-bootstrap';
import TextInput from 'react-autocomplete-input';
import 'react-autocomplete-input/dist/bundle.css';
import { AdminNav } from '../../helpers';

export default class ValidatePage extends Component {
  componentWillMount(){
    this.setState({
      data : this.props.location.state,
      riceType : this.props.location.fetchRiceType,
      desIdx : this.props.location.pageIndex
    },() => {
      let riceID = this.state.data.description[this.state.desIdx]['riceTypeID']
      this.setState({
        ...this.state,
        riceID : riceID
      })
    })
  }

  renderTableThai(objArr){
     if(objArr){
      return Object.keys(objArr[0]).map((title)=>{
        return(
          <tr>
          <td>
            <Form.Group as={Col}>
              <p>{title.slice(2,title.length).replace(/_S/g,' ').replace(/_D/g,'.').replace(/_B/g,'/')}</p>
            </Form.Group>
          </td> 
          <td>   
           <Form.Group as={Col}>
              <p>{objArr[0][title].replace(/_S/g,' ').replace(/_D/g,'.').replace(/_B/g,'/')}</p>
            </Form.Group>
            </td>
            <td>   
            <Form.Group as={Col}>
              <TextInput Component='input'
                regex={''} spacer={''} maxOptions={10}
                onChange={()=>{}}
                className='form-control' trigger={''} />
            </Form.Group>
            </td>

        </tr>
        )
      })  
     }
  }
  render() { 
    return (
      <Container>
        <AdminNav></AdminNav>
        {this.renderTableThai(this.state.riceType[this.state.riceID])}
      </Container>
    )
  }
}
